module.exports = __webpack_public_path__ + "img/long-term-cache/2bap-login-bg.dcaefa8035d61091168b532f033735db.svg";